import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ChoiceProcessModalComponent } from '../choice-process-modal/choice-process-modal.component';

@Component({
  selector: 'app-pre-sales1-modal',
  templateUrl: './pre-sales1-modal.component.html',
  styleUrls: ['./pre-sales1-modal.component.scss'],
})
export class PreSales1ModalComponent {
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PreSales1ModalComponent>
  ) {}

  gotoChoiceModal() {
    this.dialogRef.close();
    this.dialog.open(ChoiceProcessModalComponent, {
      width: '471px',
    });
  }
}
